<div class="stats-dashboard pe-3 ps-3">

  <!-- Fila 1: KPIs Principales -->
  <div class="row g-4 mb-4" *ngIf="hasSection('kpis')">
    <!-- Eficacia Ofensiva -->
    <div class="col-12 col-md-6 col-xl">
      <mat-card class="h-100 shadow-sm border-0 kpi-card">
        <mat-card-header class="d-flex justify-content-center pt-3 pb-0">
          <mat-card-title class="text-center fw-bold fs-6">Eficacia Ofensiva</mat-card-title>
        </mat-card-header>
        <mat-card-content class="d-flex flex-column align-items-center pb-2">
          <div class="gauge-container" *ngIf="offensiveGauge">
            <apx-chart
              [series]="offensiveGauge.series"
              [chart]="offensiveGauge.chart"
              [plotOptions]="offensiveGauge.plotOptions"
              [fill]="offensiveGauge.fill"
              [labels]="offensiveGauge.labels"
            ></apx-chart>
          </div>
          <div class="text-muted small text-center mt-n4 position-relative z-index-1">
            Goles: {{ stats.offensive_efficiency.successful }} / Pos: {{ stats.total_possessions_attack }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Eficacia Defensiva -->
    <div class="col-12 col-md-6 col-xl">
      <mat-card class="h-100 shadow-sm border-0 kpi-card">
        <mat-card-header class="d-flex justify-content-center pt-3 pb-0">
          <mat-card-title class="text-center fw-bold fs-6">Eficacia Defensiva</mat-card-title>
        </mat-card-header>
        <mat-card-content class="d-flex flex-column align-items-center pb-2">
          <div class="gauge-container" *ngIf="defensiveGauge">
            <apx-chart
              [series]="defensiveGauge.series"
              [chart]="defensiveGauge.chart"
              [plotOptions]="defensiveGauge.plotOptions"
              [fill]="defensiveGauge.fill"
              [labels]="defensiveGauge.labels"
            ></apx-chart>
          </div>
          <div class="text-muted small text-center mt-n4 position-relative z-index-1">
            Tiros sin gol: {{ stats.defensive_saves.successful | number:'1.0-2' }} / Tiros recibidos: {{ stats.defensive_saves.total | number:'1.0-2' }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Eficacia Paradas -->
    <div class="col-12 col-md-6 col-xl">
      <mat-card class="h-100 shadow-sm border-0 kpi-card">
        <mat-card-header class="d-flex justify-content-center pt-3 pb-0">
          <mat-card-title class="text-center fw-bold fs-6">Eficacia Paradas</mat-card-title>
        </mat-card-header>
        <mat-card-content class="d-flex flex-column align-items-center pb-2">
          <div class="gauge-container" *ngIf="savesGauge">
            <apx-chart
              [series]="savesGauge.series"
              [chart]="savesGauge.chart"
              [plotOptions]="savesGauge.plotOptions"
              [fill]="savesGauge.fill"
              [labels]="savesGauge.labels"
            ></apx-chart>
          </div>
          <div class="text-muted small text-center mt-n4 position-relative z-index-1">
            Paradas: {{ getGoalkeepingTotals().totalSaves | number:'1.0-2' }} / Tiros recibidos: {{ getGoalkeepingTotals().totalShots | number:'1.0-2' }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Pérdidas de Balón -->
    <div class="col-12 col-md-6 col-xl">
      <mat-card class="h-100 shadow-sm border-0 kpi-card bg-light">
        <mat-card-header class="d-flex justify-content-center pt-4 pb-2">
          <mat-icon class="large-icon text-warning">error_outline</mat-icon>
        </mat-card-header>
        <mat-card-content class="text-center">
          <h2 class="display-5 fw-bold text-dark mt-2 mb-0">{{ stats.losses.percentage | number:'1.1-1' }}%</h2>
          <span class="text-muted">Pérdidas de Balón</span>
          <div class="small text-muted mt-2">
            ({{ stats.losses.successful }} de {{ stats.total_possessions_attack }})
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Siete Metros -->
    <div class="col-12 col-md-6 col-xl">
      <mat-card class="h-100 shadow-sm border-0 kpi-card bg-light">
        <mat-card-header class="d-flex justify-content-center pt-4 pb-2">
          <mat-icon class="large-icon text-info">sports_handball</mat-icon>
        </mat-card-header>
        <mat-card-content class="text-center">
          <h2 class="display-5 fw-bold text-dark mt-2 mb-0">{{ stats.seven_meters.percentage | number:'1.1-1' }}%</h2>
          <span class="text-muted">Eficacia 7 Metros</span>
          <div class="small text-muted mt-2">
            ({{ stats.seven_meters.successful }} de {{ stats.seven_meters.total }})
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Fila 2: Gráficas de desgloses -->
  <div class="row g-4 mb-4" *ngIf="hasSection('throwTypeBreakdown') || hasSection('throwTypeEfficiency')">
    <!-- Análisis de Lanzamientos -->
    <div
      *ngIf="hasSection('throwTypeBreakdown')"
      [ngClass]="hasSection('throwTypeEfficiency') ? 'col-12 col-lg-6' : 'col-12'"
    >
      <mat-card class="h-100 shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Desglose de Lanzamientos</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="throwTypeChart && stats.throw_type_breakdown.length > 0; else noDataThrow">
            <apx-chart
              [series]="throwTypeChart.series"
              [chart]="throwTypeChart.chart"
              [xaxis]="throwTypeChart.xaxis"
              [plotOptions]="throwTypeChart.plotOptions"
              [dataLabels]="throwTypeChart.dataLabels"
              [legend]="throwTypeChart.legend"
            ></apx-chart>
          </div>
          <ng-template #noDataThrow>
            <div class="text-center text-muted p-5">No hay datos suficientes de tipos de lanzamiento.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Eficacia de Lanzamientos -->
    <div
      *ngIf="hasSection('throwTypeEfficiency')"
      [ngClass]="hasSection('throwTypeBreakdown') ? 'col-12 col-lg-6' : 'col-12'"
    >
      <mat-card class="h-100 shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Eficacia de Lanzamientos</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="throwTypeEfficiencyChart && stats.throw_type_breakdown.length > 0; else noDataThrowEfficiency">
            <apx-chart
              [series]="throwTypeEfficiencyChart.series"
              [chart]="throwTypeEfficiencyChart.chart"
              [xaxis]="throwTypeEfficiencyChart.xaxis"
              [yaxis]="throwTypeEfficiencyChart.yaxis"
              [plotOptions]="throwTypeEfficiencyChart.plotOptions"
              [dataLabels]="throwTypeEfficiencyChart.dataLabels"
              [tooltip]="throwTypeEfficiencyChart.tooltip"
              [legend]="throwTypeEfficiencyChart.legend"
            ></apx-chart>
          </div>
          <ng-template #noDataThrowEfficiency>
            <div class="text-center text-muted p-5">No hay datos suficientes para calcular la eficacia por tipo.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Fila 3: Modelo de juego y defensas -->
  <div class="row g-4 mb-4" *ngIf="hasSection('modelPerformance') || hasSection('defensePerformance')">
    <div
      *ngIf="hasSection('modelPerformance')"
      [ngClass]="hasSection('defensePerformance') ? 'col-12 col-lg-6' : 'col-12'"
    >
      <mat-card class="h-100 shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Rendimiento por Modelo de Juego</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="modelChart && stats.modelo_juego_distribution.length > 0; else noDataModel">
            <apx-chart
              [series]="modelChart.series"
              [chart]="modelChart.chart"
              [xaxis]="modelChart.xaxis"
              [plotOptions]="modelChart.plotOptions"
              [dataLabels]="modelChart.dataLabels"
              [tooltip]="modelChart.tooltip"
              [legend]="modelChart.legend"
            ></apx-chart>
          </div>
          <ng-template #noDataModel>
            <div class="text-center text-muted p-5">No hay datos suficientes sobre modelo de juego.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
    <div
      *ngIf="hasSection('defensePerformance')"
      [ngClass]="hasSection('modelPerformance') ? 'col-12 col-lg-6' : 'col-12'"
    >
      <mat-card class="h-100 shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Rendimiento contra Defensas Rivales (%)</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="defenseChart && stats.defense_type_distribution.length > 0; else noDataDefense">
            <apx-chart
              [series]="defenseChart.series"
              [chart]="defenseChart.chart"
              [xaxis]="defenseChart.xaxis"
              [yaxis]="defenseChart.yaxis"
              [plotOptions]="defenseChart.plotOptions"
              [dataLabels]="defenseChart.dataLabels"
              [tooltip]="defenseChart.tooltip"
              [legend]="defenseChart.legend"
            ></apx-chart>
          </div>
          <ng-template #noDataDefense>
            <div class="text-center text-muted p-5">No hay datos suficientes de defensas rivales.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>



  <!-- Fila 4: Tipos de lanzamiento por minuto -->
  <div class="row g-4 mb-4" *ngIf="hasSection('throwTypeByTime')">
    <div class="col-12">
      <mat-card class="shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Tipos de Lanzamiento por Minuto de Juego (5 min)</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="throwTypeByTimeChart && getThrowTypeByTimeInterval().length > 0; else noDataThrowTypeTime">
            <apx-chart
              [series]="throwTypeByTimeChart.series"
              [chart]="throwTypeByTimeChart.chart"
              [xaxis]="throwTypeByTimeChart.xaxis"
              [yaxis]="throwTypeByTimeChart.yaxis"
              [plotOptions]="throwTypeByTimeChart.plotOptions"
              [dataLabels]="throwTypeByTimeChart.dataLabels"
              [tooltip]="throwTypeByTimeChart.tooltip"
              [legend]="throwTypeByTimeChart.legend"
              [colors]="throwTypeByTimeChart.colors"
            ></apx-chart>
          </div>
          <ng-template #noDataThrowTypeTime>
            <div class="text-center text-muted p-5">No hay datos suficientes de lanzamientos con tiempo registrado.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>


  <!-- Fila 5: Rendimiento defensivo ante rivales -->
  <div class="row g-4 mb-4" *ngIf="hasSection('opponentAttackPerformance') || hasSection('opponentThrowBreakdown')">
    <div
      *ngIf="hasSection('opponentAttackPerformance')"
      [ngClass]="hasSection('opponentThrowBreakdown') ? 'col-12 col-lg-6' : 'col-12'"
    >
      <mat-card class="h-100 shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Rendimiento contra Ataques Rivales (%)</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="opponentAttackChart && getOpponentAttackTypeDistribution().length > 0; else noDataOpponentAttack">
            <apx-chart
              [series]="opponentAttackChart.series"
              [chart]="opponentAttackChart.chart"
              [xaxis]="opponentAttackChart.xaxis"
              [yaxis]="opponentAttackChart.yaxis"
              [plotOptions]="opponentAttackChart.plotOptions"
              [dataLabels]="opponentAttackChart.dataLabels"
              [tooltip]="opponentAttackChart.tooltip"
              [legend]="opponentAttackChart.legend"
            ></apx-chart>
          </div>
          <ng-template #noDataOpponentAttack>
            <div class="text-center text-muted p-5">No hay datos suficientes de ataques rivales.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
    <div
      *ngIf="hasSection('opponentThrowBreakdown')"
      [ngClass]="hasSection('opponentAttackPerformance') ? 'col-12 col-lg-6' : 'col-12'"
    >
      <mat-card class="h-100 shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Desglose de Lanzamientos Rivales (%)</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="opponentThrowBreakdownChart && getOpponentThrowTypeBreakdown().length > 0; else noDataOpponentThrows">
            <apx-chart
              [series]="opponentThrowBreakdownChart.series"
              [chart]="opponentThrowBreakdownChart.chart"
              [xaxis]="opponentThrowBreakdownChart.xaxis"
              [yaxis]="opponentThrowBreakdownChart.yaxis"
              [plotOptions]="opponentThrowBreakdownChart.plotOptions"
              [dataLabels]="opponentThrowBreakdownChart.dataLabels"
              [tooltip]="opponentThrowBreakdownChart.tooltip"
              [legend]="opponentThrowBreakdownChart.legend"
            ></apx-chart>
          </div>
          <ng-template #noDataOpponentThrows>
            <div class="text-center text-muted p-5">No hay datos suficientes de lanzamientos rivales.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>


  <!-- Fila 6: Goles por Tramo de Tiempo -->
  <div class="row g-4 mb-4" *ngIf="hasSection('goalsByTime')">
    <div class="col-12">
      <mat-card class="shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Evolución de Goles por Tramo de Tiempo (5 min)</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="timeChart && stats.goals_by_time_interval.length > 0; else noDataTime">
            <apx-chart
              [series]="timeChart.series"
              [chart]="timeChart.chart"
              [xaxis]="timeChart.xaxis"
              [stroke]="timeChart.stroke"
              [dataLabels]="timeChart.dataLabels"
              [legend]="timeChart.legend"
            ></apx-chart>
          </div>
          <ng-template #noDataTime>
            <div class="text-center text-muted p-5">No hay anotaciones con tiempo registrado.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>


  <!-- Fila 7: Eficacia de paradas -->
  <div class="row g-4 mb-4" *ngIf="hasSection('savesByTime')">
    <div class="col-12">
      <mat-card class="h-100 shadow-sm border-0">
        <mat-card-header class="pt-3 px-3">
          <mat-card-title class="fs-6 fw-bold">Eficacia de Paradas por Minutos (5 min)</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="savesByTimeChart && getSavesByTimeInterval().length > 0; else noDataSavesByTime">
            <apx-chart
              [series]="savesByTimeChart.series"
              [chart]="savesByTimeChart.chart"
              [xaxis]="savesByTimeChart.xaxis"
              [yaxis]="savesByTimeChart.yaxis"
              [stroke]="savesByTimeChart.stroke"
              [dataLabels]="savesByTimeChart.dataLabels"
              [tooltip]="savesByTimeChart.tooltip"
              [legend]="savesByTimeChart.legend"
            ></apx-chart>
          </div>
          <ng-template #noDataSavesByTime>
            <div class="text-center text-muted p-5">No hay datos suficientes de paradas con tiempo registrado.</div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

</div>
